import { proxyAPI } from "../proxyAPI";

export type TagKind = "category" | "industry" | "folder";

type TagOption = {
  value: string;
  label: string;
};

export const loadTagOptions =
  (kind: TagKind) =>
  async (search: string, prevOptions: TagOption[] = []) => {
    const limit = 10;
    const loadedTagCount = prevOptions.filter((option) => option.value).length;
    const params = new URLSearchParams({
      kind,
      limit: String(limit),
      offset: String(loadedTagCount),
    });

    const trimmedSearch = search.trim();
    if (trimmedSearch) {
      params.set("search", trimmedSearch);
    }

    const { data: items = [], total = 0 } = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `tags?${params.toString()}`,
    });

    return {
      options: items.map((item: string) => ({
        value: item,
        label: item,
      })),
      hasMore: loadedTagCount + items.length < total,
    };
  };